import React from 'react'
import styles from '../assets/scss/layout/_termsOfService.scss'

const termsOfService = () => (
  <div style={{ padding: '30px' }}>
    <p className="p1">
      <strong>TERMS OF SERVICE</strong>
    </p>
    <p className="p2">&nbsp;</p>
    <p className="p3">Last updated:&nbsp;07/06/2020</p>
    &nbsp;
    <ul className="ul1">
      <li className="li5">
        <span className="s1">
          <strong>Introduction</strong>
        </span>
      </li>
    </ul>
    <p className="p6">
      <span className="s2">Welcome to&nbsp;</span>
      <strong>Sonder Social Inc.</strong>&nbsp;(&ldquo;<strong>Company</strong>
      &rdquo;, &ldquo;<strong>we</strong>&rdquo;, &ldquo;<strong>our</strong>
      &rdquo;, &ldquo;<strong>us</strong>&rdquo;)! As you have just clicked our
      Terms of Service, please pause, grab a cup of coffee and carefully read
      the following pages. It will take you approximately 20&nbsp;minutes.
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p8">
      These Terms of Service (&ldquo;<strong>Terms</strong>&rdquo;, &ldquo;
      <strong>Terms of Service</strong>&rdquo;) govern your use of&nbsp;our
      mobile application&nbsp;Sonder
      <span className="s2">&nbsp;operated by&nbsp;Sonder Social Inc.</span>
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p8">
      Our Privacy Policy also governs your use of our Service and explains how
      we collect, safeguard and disclose information that results from your use
      of our web pages. Please read it here
      https://www.sonder.social/privacypolicy/.
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p8">
      Your agreement with us includes these Terms&nbsp;and our Privacy
      Policy&nbsp;(&ldquo;<strong>Agreements</strong>&rdquo;). You acknowledge
      that you have read and understood Agreements, and agree to be bound of
      them.
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p8">
      If you do not agree with (or cannot comply with) Agreements, then you may
      not use the Service, but please let us know by emailing at
      contact@sonder.social so we can try to find a solution. These Terms apply
      to all visitors, users and others who wish to access or use Service.
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p8">Thank you for being responsible.</p>
    <p className="p7">&nbsp;</p>
    <ul className="ul1">
      <li className="li5">
        <span className="s1">
          <strong>Communications</strong>
        </span>
      </li>
    </ul>
    <p className="p8">
      By creating an Account on our Service, you agree to subscribe to
      newsletters, marketing or promotional materials and other information we
      may send. However, you may opt out of receiving any, or all, of these
      communications from us by following the unsubscribe link or by emailing
      at.
    </p>
    <p className="p7">&nbsp;</p>
    <ul className="ul1">
      <li className="li5">
        <span className="s1">
          <strong>Fee Changes</strong>
        </span>
      </li>
    </ul>
    <p className="p6">
      Sonder Social Inc., in its sole discretion and at any time, may modify
      Subscription fees for the Subscriptions. Any Subscription fee change will
      become effective at the end of the then-current Billing Cycle.
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p6">
      Sonder Social Inc.&nbsp;will provide you with a reasonable prior notice of
      any change in Subscription fees to give you an opportunity to terminate
      your Subscription before such change becomes effective.
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p8">
      Your continued use of Service after Subscription fee change comes into
      effect constitutes your agreement to pay the modified Subscription fee
      amount.
    </p>
    <p className="p7">&nbsp;</p>
    <ul className="ul1">
      <li className="li5">
        <span className="s1">
          <strong>Refunds</strong>
        </span>
      </li>
    </ul>
    <p className="p8">
      Except when required by law, paid Subscription fees are non-refundable.
    </p>
    <p className="p7">&nbsp;</p>
    <ul className="ul1">
      <li className="li5">
        <span className="s1">
          <strong>Content</strong>
        </span>
      </li>
    </ul>
    <p className="p8">
      Content found on or through this Service are the property of&nbsp;Sonder
      Social Inc.&nbsp;or used with permission. You may not distribute, modify,
      transmit, reuse, download, repost, copy, or use said Content, whether in
      whole or in part, for commercial purposes or for personal gain, without
      express advance written permission from us.
    </p>
    <p className="p7">&nbsp;</p>
    <ul className="ul1">
      <li className="li5">
        <span className="s1">
          <strong>Prohibited Uses</strong>
        </span>
      </li>
    </ul>
    <p className="p8">
      You may use Service only for lawful purposes and in accordance with Terms.
      You agree not to use Service:
    </p>
    <p className="p7">&nbsp;</p>
    <ul className="ul1">
      <ul className="ul1">
        <li className="li5">
          In any way that violates any applicable national or international law
          or regulation.
        </li>
      </ul>
    </ul>
    <p className="p9">&nbsp;</p>
    <ul className="ul1">
      <ul className="ul1">
        <li className="li5">
          For the purpose of exploiting, harming, or attempting to exploit or
          harm minors in any way by exposing them to inappropriate content or
          otherwise.
        </li>
      </ul>
    </ul>
    <p className="p9">&nbsp;</p>
    <ul className="ul1">
      <ul className="ul1">
        <li className="li5">
          To transmit, or procure the sending of, any advertising or promotional
          material, including any &ldquo;junk mail&rdquo;, &ldquo;chain
          letter,&rdquo; &ldquo;spam,&rdquo; or any other similar solicitation.
        </li>
      </ul>
    </ul>
    <p className="p9">&nbsp;</p>
    <ul className="ul1">
      <ul className="ul1">
        <li className="li5">
          To impersonate or attempt to impersonate Company, a Company employee,
          another user, or any other person or entity.
        </li>
      </ul>
    </ul>
    <p className="p9">&nbsp;</p>
    <ul className="ul1">
      <ul className="ul1">
        <li className="li5">
          In any way that infringes upon the rights of others, or in any way is
          illegal, threatening, fraudulent, or harmful, or in connection with
          any unlawful, illegal, fraudulent, or harmful purpose or activity.
        </li>
      </ul>
    </ul>
    <p className="p9">&nbsp;</p>
    <ul className="ul1">
      <ul className="ul1">
        <li className="li5">
          To engage in any other conduct that restricts or inhibits
          anyone&rsquo;s use or enjoyment of Service, or which, as determined by
          us, may harm or offend Company or users of Service or expose them to
          liability.
        </li>
      </ul>
    </ul>
    <p className="p10">&nbsp;</p>
    <p className="p8">Additionally, you agree not to:</p>
    <p className="p11">&nbsp;</p>
    <ul className="ul1">
      <ul className="ul1">
        <li className="li5">
          Use Service in any manner that could disable, overburden, damage, or
          impair Service or interfere with any other party&rsquo;s use of
          Service, including their ability to engage in real time activities
          through Service.
        </li>
      </ul>
    </ul>
    <p className="p9">&nbsp;</p>
    <ul className="ul1">
      <ul className="ul1">
        <li className="li5">
          Use any robot, spider, or other automatic device, process, or means to
          access Service for any purpose, including monitoring or copying any of
          the material on Service.
        </li>
      </ul>
    </ul>
    <p className="p9">&nbsp;</p>
    <ul className="ul1">
      <ul className="ul1">
        <li className="li5">
          Use any manual process to monitor or copy any of the material on
          Service or for any other unauthorized purpose without our prior
          written consent.
        </li>
      </ul>
    </ul>
    <p className="p9">&nbsp;</p>
    <ul className="ul1">
      <ul className="ul1">
        <li className="li5">
          Use any device, software, or routine that interferes with the proper
          working of Service.
        </li>
      </ul>
    </ul>
    <p className="p9">&nbsp;</p>
    <ul className="ul1">
      <ul className="ul1">
        <li className="li5">
          Introduce any viruses, trojan horses, worms, logic bombs, or other
          material which is malicious or technologically harmful.
        </li>
      </ul>
    </ul>
    <p className="p9">&nbsp;</p>
    <ul className="ul1">
      <ul className="ul1">
        <li className="li5">
          Attempt to gain unauthorized access to, interfere with, damage, or
          disrupt any parts of Service, the server on which Service is stored,
          or any server, computer, or database connected to Service.
        </li>
      </ul>
    </ul>
    <p className="p9">&nbsp;</p>
    <ul className="ul1">
      <ul className="ul1">
        <li className="li5">
          Attack Service via a denial-of-service attack or a distributed
          denial-of-service attack.
        </li>
      </ul>
    </ul>
    <p className="p9">&nbsp;</p>
    <ul className="ul1">
      <ul className="ul1">
        <li className="li5">
          Take any action that may damage or falsify Company rating.
        </li>
      </ul>
    </ul>
    <p className="p9">&nbsp;</p>
    <ul className="ul1">
      <ul className="ul1">
        <li className="li5">
          Otherwise attempt to interfere with the proper working of Service.
        </li>
      </ul>
    </ul>
    <p className="p12">&nbsp;</p>
    <ul className="ul1">
      <li className="li5">
        <span className="s1">
          <strong>Analytics</strong>
        </span>
      </li>
    </ul>
    <p className="p10">&nbsp;</p>
    <p className="p6">
      We may use third-party Service Providers to monitor and analyze the use of
      our Service.
    </p>
    <p className="p4">&nbsp;</p>
    <ul className="ul1">
      <ul className="ul1">
        <li className="li5">
          <strong>Google Analytics</strong>
        </li>
      </ul>
    </ul>
    <p className="p6">
      Google Analytics is a web analytics service offered by Google that tracks
      and reports website traffic. Google uses the data collected to track and
      monitor the use of our Service. This data is shared with other Google
      services. Google may use the collected data to contextualise and
      personalise the ads of its own advertising network.
    </p>
    <p className="p10">&nbsp;</p>
    <p className="p6">
      For more information on the privacy practices of Google, please visit the
      Google Privacy Terms web page:{' '}
      <span className="s3">https://policies.google.com/privacy?hl=en</span>
    </p>
    <p className="p13">&nbsp;</p>
    <p className="p6">
      We also encourage you to review the Google's policy for safeguarding your
      data:{' '}
      <span className="s3">
        https://support.google.com/analytics/answer/6004245
      </span>
      .
    </p>
    <p className="p10">&nbsp;</p>
    <p className="p6">
      <strong>Firebase</strong>
    </p>
    <p className="p6">Firebase is analytics service provided by Google Inc.</p>
    <p className="p10">&nbsp;</p>
    <p className="p6">
      You may opt-out of certain Firebase features through your mobile device
      settings, such as your device advertising settings or by following the
      instructions provided by Google in their Privacy Policy:{' '}
      <span className="s3">https://policies.google.com/privacy?hl=en</span>
    </p>
    <p className="p13">&nbsp;</p>
    <p className="p6">
      For more information on what type of information Firebase collects, please
      visit the Google Privacy Terms web page:{' '}
      <span className="s3">https://policies.google.com/privacy?hl=en</span>
    </p>
    <p className="p13">&nbsp;</p>
    <p className="p10">&nbsp;</p>
    <ul className="ul1">
      <li className="li5">
        <span className="s1">
          <strong>No Use By Minors</strong>
        </span>
      </li>
    </ul>
    <p className="p8">
      Service is intended only for access and use by individuals at least
      eighteen (18) years old. By accessing or using any of Company, you warrant
      and represent that you are at least eighteen (18) years of age and with
      the full authority, right, and capacity to enter into this agreement and
      abide by all of the terms and conditions of Terms. If you are not at least
      eighteen (18) years old, you are prohibited from both the access and usage
      of Service.
    </p>
    <p className="p7">&nbsp;</p>
    <ul className="ul1">
      <li className="li5">
        <span className="s1">
          <strong>Accounts</strong>
        </span>
      </li>
    </ul>
    <p className="p8">
      When you create an account with us, you guarantee that you are above the
      age of 18, and that the information you provide us is accurate, complete,
      and current at all times. Inaccurate, incomplete, or obsolete information
      may result in the immediate termination of your account on Service.
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p8">
      You are responsible for maintaining the confidentiality of your account
      and password, including but not limited to the restriction of access to
      your computer and/or account. You agree to accept responsibility for any
      and all activities or actions that occur under your account and/or
      password, whether your password is with our Service or a third-party
      service. You must notify us immediately upon becoming aware of any breach
      of security or unauthorized use of your account.
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p8">
      You may not use as a username the name of another person or entity or that
      is not lawfully available for use, a name or trademark that is subject to
      any rights of another person or entity other than you, without appropriate
      authorization. You may not use as a username any name that is offensive,
      vulgar or obscene.
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p8">
      We reserve the right to refuse service, terminate accounts, remove or edit
      content, or cancel orders in our sole discretion.
    </p>
    <p className="p7">&nbsp;</p>
    <ul className="ul1">
      <li className="li5">
        <span className="s1">
          <strong>Intellectual Property</strong>
        </span>
      </li>
    </ul>
    <p className="p8">
      Service and its original content (excluding Content provided by users),
      features and functionality are and will remain the exclusive property
      of&nbsp;Sonder Social Inc.&nbsp;and its licensors. Service is protected by
      copyright, trademark, and other laws of&nbsp;the United States. Our
      trademarks and trade dress may not be used in connection with any product
      or service without the prior written consent of&nbsp;Sonder Social Inc..
    </p>
    <p className="p7">&nbsp;</p>
    <ul className="ul1">
      <li className="li5">
        <span className="s1">
          <strong>Copyright Policy</strong>
        </span>
      </li>
    </ul>
    <p className="p8">
      We respect the intellectual property rights of others. It is our policy to
      respond to any claim that Content posted on Service infringes on the
      copyright or other intellectual property rights (&ldquo;
      <strong>Infringement</strong>&rdquo;) of any person or entity.
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p8">
      If you are a copyright owner, or authorized on behalf of one, and you
      believe that the copyrighted work has been copied in a way that
      constitutes copyright infringement, please submit your claim via email
      to&nbsp;contact@sonder.social, with the subject line: &ldquo;Copyright
      Infringement&rdquo; and include in your claim a detailed description of
      the alleged Infringement as detailed below, under &ldquo;DMCA Notice and
      Procedure for Copyright Infringement Claims&rdquo;
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p8">
      You may be held accountable for damages (including costs and attorneys'
      fees) for misrepresentation or bad-faith claims on the infringement of any
      Content found on and/or through Service on your copyright.
    </p>
    <p className="p7">&nbsp;</p>
    <ul className="ul1">
      <li className="li5">
        <span className="s1">
          <strong>
            DMCA Notice and Procedure for Copyright Infringement Claims
          </strong>
        </span>
      </li>
    </ul>
    <p className="p8">
      You may submit a notification pursuant to the Digital Millennium Copyright
      Act (DMCA) by providing our Copyright Agent with the following information
      in writing (see 17 U.S.C 512(c)(3) for further detail):
    </p>
    <p className="p11">&nbsp;</p>
    <ul className="ul1">
      <ul className="ul1">
        <li className="li5">
          an electronic or physical signature of the person authorized to act on
          behalf of the owner of the copyright's interest;
        </li>
      </ul>
    </ul>
    <p className="p9">&nbsp;</p>
    <ul className="ul1">
      <ul className="ul1">
        <li className="li5">
          a description of the copyrighted work that you claim has been
          infringed, including the URL (i.e., web page address) of the location
          where the copyrighted work exists or a copy of the copyrighted work;
        </li>
      </ul>
    </ul>
    <p className="p9">&nbsp;</p>
    <ul className="ul1">
      <ul className="ul1">
        <li className="li5">
          identification of the URL or other specific location on Service where
          the material that you claim is infringing is located;
        </li>
      </ul>
    </ul>
    <p className="p9">&nbsp;</p>
    <ul className="ul1">
      <ul className="ul1">
        <li className="li5">
          your address, telephone number, and email address;
        </li>
      </ul>
    </ul>
    <p className="p9">&nbsp;</p>
    <ul className="ul1">
      <ul className="ul1">
        <li className="li5">
          a statement by you that you have a good faith belief that the disputed
          use is not authorized by the copyright owner, its agent, or the law;
        </li>
      </ul>
    </ul>
    <p className="p9">&nbsp;</p>
    <ul className="ul1">
      <ul className="ul1">
        <li className="li5">
          a statement by you, made under penalty of perjury, that the above
          information in your notice is accurate and that you are the copyright
          owner or authorized to act on the copyright owner's behalf.
        </li>
      </ul>
    </ul>
    <p className="p10">&nbsp;</p>
    <p className="p8">
      You can contact our Copyright Agent via email
      at&nbsp;contact@sonder.social
    </p>
    <p className="p7">&nbsp;</p>
    <ul className="ul1">
      <li className="li5">
        <span className="s1">
          <strong>Error Reporting and Feedback</strong>
        </span>
      </li>
    </ul>
    <p className="p8">
      You may provide us&nbsp;either directly at contact@sonder.social or via
      third party sites and tools&nbsp;with information and feedback concerning
      errors, suggestions for improvements, ideas, problems, complaints, and
      other matters related to our Service (&ldquo;<strong>Feedback</strong>
      &rdquo;). You acknowledge and agree that: (i) you shall not retain,
      acquire or assert any intellectual property right or other right, title or
      interest in or to the Feedback; (ii) Company may have development ideas
      similar to the Feedback; (iii) Feedback does not contain confidential
      information or proprietary information from you or any third party; and
      (iv) Company is not under any obligation of confidentiality with respect
      to the Feedback. In the event the transfer of the ownership to the
      Feedback is not possible due to applicable mandatory laws, you grant
      Company and its affiliates an exclusive, transferable, irrevocable,
      free-of-charge, sub-licensable, unlimited and perpetual right to use
      (including copy, modify, create derivative works, publish, distribute and
      commercialize) Feedback in any manner and for any purpose.
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p8">
      The third party sites and tools mentioned above include the following:
    </p>
    <p className="p7">&nbsp;</p>
    <ul className="ul1">
      <ul className="ul1">
        <li className="li5">
          <strong>Firebase Crashlytics</strong>
        </li>
      </ul>
    </ul>
    <p className="p8">
      Firebase Crashlytics is bug reporting service provided by Google Inc.
    </p>
    <p className="p10">&nbsp;</p>
    <p className="p6">
      You may opt-out of certain Firebase features through your mobile device
      settings, such as your device advertising settings or by following the
      instructions provided by Google in their Privacy Policy:
      https://policies.google.com/privacy?hl=en
    </p>
    <p className="p10">&nbsp;</p>
    <p className="p6">
      For more information on what type of information Firebase collects, please
      visit the Google Privacy Terms web page:
      https://policies.google.com/privacy?hl=en
    </p>
    <p className="p10">&nbsp;</p>
    <ul className="ul1">
      <li className="li5">
        <span className="s1">
          <strong>Links To Other Web Sites</strong>
        </span>
      </li>
    </ul>
    <p className="p8">
      Our Service may contain links to third party web sites or services that
      are not owned or controlled by&nbsp;Sonder Social Inc.
    </p>
    <p className="p10">&nbsp;</p>
    <p className="p6">
      Sonder Social Inc.&nbsp;has no control over, and assumes no responsibility
      for the content, privacy policies, or practices of any third party web
      sites or services. We do not warrant the offerings of any of these
      entities/individuals or their websites.
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p6">
      <span className="s2">YOU ACKNOWLEDGE AND AGREE THAT&nbsp;</span>Sonder
      Social Inc.&nbsp;SHALL NOT BE RESPONSIBLE OR LIABLE, DIRECTLY OR
      INDIRECTLY, FOR ANY DAMAGE OR LOSS CAUSED OR ALLEGED TO BE CAUSED BY OR IN
      CONNECTION WITH USE OF OR RELIANCE ON ANY SUCH CONTENT, GOODS OR SERVICES
      AVAILABLE ON OR THROUGH ANY SUCH THIRD PARTY WEB SITES OR SERVICES.
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p8">
      WE STRONGLY ADVISE YOU TO READ THE TERMS OF SERVICE AND PRIVACY POLICIES
      OF ANY THIRD PARTY WEB SITES OR SERVICES THAT YOU VISIT.
    </p>
    <p className="p7">&nbsp;</p>
    <ul className="ul1">
      <li className="li5">
        <span className="s1">
          <strong>Disclaimer Of Warranty </strong>
        </span>
      </li>
    </ul>
    <p className="p8">
      THESE SERVICES ARE PROVIDED BY COMPANY ON AN &ldquo;AS IS&rdquo; AND
      &ldquo;AS AVAILABLE&rdquo; BASIS. COMPANY MAKES NO REPRESENTATIONS OR
      WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF THEIR
      SERVICES, OR THE INFORMATION, CONTENT OR MATERIALS INCLUDED THEREIN. YOU
      EXPRESSLY AGREE THAT YOUR USE OF THESE SERVICES, THEIR CONTENT, AND ANY
      SERVICES OR ITEMS OBTAINED FROM US IS AT YOUR SOLE RISK.
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p8">
      NEITHER COMPANY NOR ANY PERSON ASSOCIATED WITH COMPANY MAKES ANY WARRANTY
      OR REPRESENTATION WITH RESPECT TO THE COMPLETENESS, SECURITY, RELIABILITY,
      QUALITY, ACCURACY, OR AVAILABILITY OF THE SERVICES. WITHOUT LIMITING THE
      FOREGOING, NEITHER COMPANY NOR ANYONE ASSOCIATED WITH COMPANY REPRESENTS
      OR WARRANTS THAT THE SERVICES, THEIR CONTENT, OR ANY SERVICES OR ITEMS
      OBTAINED THROUGH THE SERVICES WILL BE ACCURATE, RELIABLE, ERROR-FREE, OR
      UNINTERRUPTED, THAT DEFECTS WILL BE CORRECTED, THAT THE SERVICES OR THE
      SERVER THAT MAKES IT AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL
      COMPONENTS OR THAT THE SERVICES OR ANY SERVICES OR ITEMS OBTAINED THROUGH
      THE SERVICES WILL OTHERWISE MEET YOUR NEEDS OR EXPECTATIONS.
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p8">
      COMPANY HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR
      IMPLIED, STATUTORY, OR OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY
      WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT, AND FITNESS FOR
      PARTICULAR PURPOSE.
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p8">
      THE FOREGOING DOES NOT AFFECT ANY WARRANTIES WHICH CANNOT BE EXCLUDED OR
      LIMITED UNDER APPLICABLE LAW.
    </p>
    <p className="p7">&nbsp;</p>
    <ul className="ul1">
      <li className="li5">
        <span className="s1">
          <strong>Limitation Of Liability</strong>
        </span>
      </li>
    </ul>
    <p className="p8">
      EXCEPT AS PROHIBITED BY LAW, YOU WILL HOLD US AND OUR OFFICERS, DIRECTORS,
      EMPLOYEES, AND AGENTS HARMLESS FOR ANY INDIRECT, PUNITIVE, SPECIAL,
      INCIDENTAL, OR CONSEQUENTIAL DAMAGE, HOWEVER IT ARISES (INCLUDING
      ATTORNEYS' FEES AND ALL RELATED COSTS AND EXPENSES OF LITIGATION AND
      ARBITRATION, OR AT TRIAL OR ON APPEAL, IF ANY, WHETHER OR NOT LITIGATION
      OR ARBITRATION IS INSTITUTED), WHETHER IN AN ACTION OF CONTRACT,
      NEGLIGENCE, OR OTHER TORTIOUS ACTION, OR ARISING OUT OF OR IN CONNECTION
      WITH THIS AGREEMENT, INCLUDING WITHOUT LIMITATION ANY CLAIM FOR PERSONAL
      INJURY OR PROPERTY DAMAGE, ARISING FROM THIS AGREEMENT AND ANY VIOLATION
      BY YOU OF ANY FEDERAL, STATE, OR LOCAL LAWS, STATUTES, RULES, OR
      REGULATIONS, EVEN IF COMPANY HAS BEEN PREVIOUSLY ADVISED OF THE
      POSSIBILITY OF SUCH DAMAGE. EXCEPT AS PROHIBITED BY LAW, IF THERE IS
      LIABILITY FOUND ON THE PART OF COMPANY, IT WILL BE LIMITED TO THE AMOUNT
      PAID FOR THE PRODUCTS AND/OR SERVICES, AND UNDER NO CIRCUMSTANCES WILL
      THERE BE CONSEQUENTIAL OR PUNITIVE DAMAGES. SOME STATES DO NOT ALLOW THE
      EXCLUSION OR LIMITATION OF PUNITIVE, INCIDENTAL OR CONSEQUENTIAL DAMAGES,
      SO THE PRIOR LIMITATION OR EXCLUSION MAY NOT APPLY TO YOU.
    </p>
    <p className="p7">&nbsp;</p>
    <ul className="ul1">
      <li className="li5">
        <span className="s1">
          <strong>Termination</strong>
        </span>
      </li>
    </ul>
    <p className="p8">
      We may terminate or suspend your account and bar access to Service
      immediately, without prior notice or liability, under our sole discretion,
      for any reason whatsoever and without limitation, including but not
      limited to a breach of Terms.
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p8">
      If you wish to terminate your account, you may simply discontinue using
      Service.
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p8">
      All provisions of Terms which by their nature should survive termination
      shall survive termination, including, without limitation, ownership
      provisions, warranty disclaimers, indemnity and limitations of liability.
    </p>
    <p className="p7">&nbsp;</p>
    <ul className="ul1">
      <li className="li5">
        <span className="s1">
          <strong>Governing Law</strong>
        </span>
      </li>
    </ul>
    <p className="p8">
      These Terms shall be governed and construed in accordance with the laws
      of&nbsp;State of California&nbsp;without regard to its conflict of law
      provisions.
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p8">
      Our failure to enforce any right or provision of these Terms will not be
      considered a waiver of those rights. If any provision of these Terms is
      held to be invalid or unenforceable by a court, the remaining provisions
      of these Terms will remain in effect. These Terms constitute the entire
      agreement between us regarding our Service and supersede and replace any
      prior agreements we might have had between us regarding Service.
    </p>
    <p className="p7">&nbsp;</p>
    <ul className="ul1">
      <li className="li5">
        <span className="s1">
          <strong>Changes To Service</strong>
        </span>
      </li>
    </ul>
    <p className="p8">
      We reserve the right to withdraw or amend our Service, and any service or
      material we provide via Service, in our sole discretion without notice. We
      will not be liable if for any reason all or any part of Service is
      unavailable at any time or for any period. From time to time, we may
      restrict access to some parts of Service, or the entire Service, to users,
      including registered users.
    </p>
    <p className="p7">&nbsp;</p>
    <ul className="ul1">
      <li className="li5">
        <span className="s1">
          <strong>Amendments To Terms</strong>
        </span>
      </li>
    </ul>
    <p className="p8">
      We may amend Terms at any time by posting the amended terms on this site.
      It is your responsibility to review these Terms periodically.
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p8">
      Your continued use of the Platform following the posting of revised Terms
      means that you accept and agree to the changes. You are expected to check
      this page frequently so you are aware of any changes, as they are binding
      on you.
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p8">
      By continuing to access or use our Service after any revisions become
      effective, you agree to be bound by the revised terms. If you do not agree
      to the new terms, you are no longer authorized to use Service.
    </p>
    <p className="p7">&nbsp;</p>
    <ul className="ul1">
      <li className="li5">
        <span className="s1">
          <strong>Waiver And Severability</strong>
        </span>
      </li>
    </ul>
    <p className="p8">
      No waiver by Company of any term or condition set forth in Terms shall be
      deemed a further or continuing waiver of such term or condition or a
      waiver of any other term or condition, and any failure of Company to
      assert a right or provision under Terms shall not constitute a waiver of
      such right or provision.
    </p>
    <p className="p7">&nbsp;</p>
    <p className="p8">
      If any provision of Terms is held by a court or other tribunal of
      competent jurisdiction to be invalid, illegal or unenforceable for any
      reason, such provision shall be eliminated or limited to the minimum
      extent such that the remaining provisions of Terms will continue in full
      force and effect.
    </p>
    <p className="p7">&nbsp;</p>
    <ul className="ul1">
      <li className="li5">
        <span className="s1">
          <strong>Acknowledgement</strong>
        </span>
      </li>
    </ul>
    <p className="p8">
      BY USING SERVICE OR OTHER SERVICES PROVIDED BY US, YOU ACKNOWLEDGE THAT
      YOU HAVE READ THESE TERMS OF SERVICE AND AGREE TO BE BOUND BY THEM.
    </p>
    <p className="p7">&nbsp;</p>
    <ul className="ul1">
      <li className="li5">
        <span className="s1">
          <strong>Contact Us</strong>
        </span>
      </li>
    </ul>
    <p className="p8">
      Please send your feedback, comments, requests for technical support:
    </p>
    <p className="p8">By email: contact@sonder.social.</p>
    <p className="p8">
      By visiting this page on our website: https://www.sonder.social/.
    </p>
    <p className="p8">By phone number: +16232088664.</p>
    <p className="p8">By mail: 1955 Courtland Ave, Oakland, CA 94601.</p>
  </div>
)

export default termsOfService



// WEBPACK FOOTER //
// ./src/pages/termsOfService.js